import { useState, useMemo, useCallback } from 'react';
import { BoardV3 } from '../boardv3/components/BoardV3';
import { BoardV3FloatingToolbar } from '../boardv3/components/toolbar';
import { createBoardLayoutStore } from '../boardv3/components/boardLayoutStore';
import { BoardLayoutProvider, type ViewControls } from '../boardv3/components/BoardLayoutContext';
import { useBoardTaskDetailLevel } from '../boardv3/hooks/useBoardTaskDetailLevel';
import { useBoardHeaderResize } from '../boardv3/hooks/useBoardHeaderResize';
import { useBoardSidebarResize } from '../boardv3/hooks/useBoardSidebarResize';
import { getInitialSidebarState } from '../boardv3/hooks/useBoardSidebarResize';
import { getInitialHeaderState } from '../boardv3/hooks/useBoardHeaderResize';
import { getInitialDetailState } from '../boardv3/hooks/useBoardTaskDetailLevel';
import { BASE_DAY_WIDTH } from '../boardv3/utils/boardHelpers';

export function LandingBoardView() {
  const [zoomLevel, setZoomLevel] = useState(1.0);
  const dayWidth = BASE_DAY_WIDTH * zoomLevel;

  const layoutStore = useMemo(() => {
    const initialSidebar = getInitialSidebarState();
    const initialHeader = getInitialHeaderState(dayWidth);
    const initialDetail = getInitialDetailState();
    const { headerHeight: initHeaderHeight, ...headerRest } = initialHeader;
    const { rowHeight: initRowHeight, ...detailRest } = initialDetail;
    return createBoardLayoutStore({
      dayWidth,
      rowHeight: initRowHeight,
      headerHeight: initHeaderHeight,
      columnYOffsets: {},
      rowAssignments: {},
      tasksByColumn: {},
      totalHeight: 0,
      totalDays: 0,
      visibleWeeks: [],
      ...initialSidebar,
      ...headerRest,
      ...detailRest,
    });
  }, []);

  const taskDetail = useBoardTaskDetailLevel(layoutStore);
  const headerResize = useBoardHeaderResize(dayWidth, layoutStore);
  const sidebarResize = useBoardSidebarResize(layoutStore);

  const viewControls = useMemo(
    (): ViewControls => ({
      header: headerResize,
      sidebar: sidebarResize,
      taskDetail,
    }),
    [headerResize, sidebarResize, taskDetail],
  );

  const handleSetZoom = useCallback((level: number) => {
    setZoomLevel(Math.max(0.1, Math.min(20.0, level)));
  }, []);

  return (
    <BoardLayoutProvider store={layoutStore} viewControls={viewControls}>
      <div className="landing-demo-board-wrapper">
        <div className="landing-demo-board-content">
          <BoardV3 zoomLevel={zoomLevel} onZoomChange={handleSetZoom} />
        </div>
        <BoardV3FloatingToolbar onAddTask={() => {}} />
      </div>
    </BoardLayoutProvider>
  );
}
